<template>
  <div v-if="tagName" class="logistics-tag" :style="tagStyle">
    {{ tagName }}
  </div>
</template>

<script>
export default {
  name: "LogisticsTag",
  props: {
    type: {
      type: [Number, String],
      required: true
    }
  },
  computed: {
    tagType() {
      return Number(this.type);
    },
    tagName() {
      const names = {
        0: "自提",
        1: "本地配送",
        2: "直邮"
      };
      return names[this.tagType] ?? "";
    },
    tagStyle() {
      const colors = {
        0: {
          color: "#FF9900",
          backgroundColor: "#FFF5E6"
        },
        1: {
          color: "#2E90FF",
          backgroundColor: "#E8F4FF"
        },
        2: {
          color: "#722ED1",
          backgroundColor: "#F9F0FF"
        }
      };
      const theme = colors[this.tagType] || {};
      return {
        color: theme.color,
        backgroundColor: theme.backgroundColor,
        borderColor: theme.color
      };
    }
  }
};
</script>

<style lang="less" scoped>
.logistics-tag {
  display: flex;
  justify-content: center;
  align-items: center;
  // display: inline-block;
  // vertical-align: middle;
  box-sizing: border-box;
  border: 0.5px solid;
  border-radius: 2px;
  padding: 1px 4px;
  font-size: 10px;
  line-height: 10px;
  font-weight: 500;
  margin-right: 4px;
  &:last-child {
    margin-right: 0;
  }
}
</style>
